import { useMemberData } from '@maxpreps/shared/redux/user/userHooks';
import Font from '@maxpreps/shared/styles/font';
import styled from 'styled-components';
import { getSignOutUrl, PROFILE_URL } from '../../constants/urls';
import THEME from '../../styles/colors';
import Anchor from '../Anchor/Anchor';
import Mugshot from '../Image/Mugshot';

const StyledUserBox = styled.div`
  padding: 28px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  border-bottom: 1px solid ${THEME.general.border};
  margin-bottom: 16px;
`;

const UserBox: React.FC = () => {
  const memberData = useMemberData();

  const { name, photoUrl } = memberData ?? {};

  const signOutUrl = getSignOutUrl();

  return (
    <StyledUserBox>
      <Anchor href={PROFILE_URL}>
        <Mugshot src={photoUrl} alt={name ?? 'User'} size={80} />
      </Anchor>
      <Anchor
        href={PROFILE_URL}
        className={Font.f28_heavy}
        $display="block"
        $padding="8px 0 2px 0"
        $color={THEME.text.primary}
      >
        {name}
      </Anchor>
      <Anchor
        href={signOutUrl}
        className={Font.f14_tall}
        $color={THEME.text.tertiary}
        $display="block"
        $marginTop="6px"
      >
        Sign Out
      </Anchor>
    </StyledUserBox>
  );
};

export default UserBox;
